import { Expose, Type } from 'class-transformer'
import { IsDefined, ValidateNested } from 'class-validator'
import { ApplicationVersion } from '../../entity'

export class ListApplicationVersionsDTO {

    @Expose()
    @IsDefined()
    @Type( type => ApplicationVersion )
    @ValidateNested()
    applicationVersions!: ApplicationVersion[]

    @Expose()
    @IsDefined()
    pagination!: {
        page: number
        from: number
        to: number
        count: number
    }

}